import React from "react";
import images from "../../../images";

const BadgeCard = ({
    isCompleted = false,
    level,
    xp,
    coin,
    image,
    isLast = false, // true nếu là huy hiệu cuối cùng
    fadedLevel = 0, // 0: rõ nét, 1: mờ nhẹ, 2: mờ nhiều
}) => {
    const getFadedClass = () => {
        if (fadedLevel === 1) return "opacity-90 blur-[1.25px]";
        if (fadedLevel === 2) return "opacity-90 blur-[5px]";
        return "opacity-100";
    };

    const getTextColor = () => {
        return fadedLevel > 0 ? "text-[#A0A0A0]" : "text-[#253FF6]";
    };

    return (
        <div
            className={`relative flex items-center gap-4 mb-8 transition-all ${getFadedClass()}`}
        >
            <div className="relative flex-shrink-0">
                <img
                    src={image}
                    alt="badges"
                    className="w-[90px] h-[90px] object-contain"
                />
            </div>

            <div>
                <div className={`font-bold text-sm ${getTextColor()}`}>
                    Level {level}
                </div>
                {/* Nếu chưa đạt được huy hiệu sẽ hiển thị thông tin để đạt được huy hiệu  */}
                {isCompleted ? (
                    <div className="text-sm mb-1 text-[#253FF6] font-medium">
                        Completion of {level}st quest
                    </div>
                ) : (
                    <div className="flex flex-col items-start gap-1 text-base mt-1">
                        <div className="flex items-center gap-2">
                            <img
                                className="w-5 h-5"
                                src={images.RallyXPSmallBlueIcon}
                                alt="rally xp"
                            />
                            <span className="font-bold text-[#253FF6]">
                                {xp}
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <img
                                className="w-5 h-5"
                                src={images.RallyCoins}
                                alt="rally coin"
                            />
                            <span className="font-bold text-[#253FF6]">
                                Up to {coin}
                            </span>
                        </div>
                    </div>
                )}
            </div>
            {/* nếu là huy hiệu cuối cùng sẽ không hiển thị đường kẻ */}
            {!isLast && (
                <div className="absolute -bottom-[60px] left-11 rounded-full h-[67px] border-l-[3px] border-dotted border-[#253FF6]"></div>
            )}
        </div>
    );
};

export default BadgeCard;
